const TOKEN_KEY = "ACCESS_TOKEN";

export const isAuthenticated = () => {
    return !!localStorage.getItem(TOKEN_KEY);
}

export const getAccessToken = () => {
    return localStorage.getItem(TOKEN_KEY);
}

export const setAccessToken = token => {
    localStorage.setItem(TOKEN_KEY, token);
}
